import { parseEnv } from '@nohara-dxdev/react-core';
import z from 'zod';

export const env = parseEnv({
  HOME_API_ENDPOINT: z.string().url(),
  API_ENDPOINT: z.string().url(),
  POSTAL_CODE_API_ENDPOINT: z
    .string()
    .url()
    .default(import.meta.env.VITE_POSTAL_CODE_API_ENDPOINT),
  HANDSONTABLE_LICENSE_KEY: z.string().default(import.meta.env.VITE_HANDSONTABLE_LICENSE_KEY),
  OAUTH_DOMAIN: z.string(),
  APP_ID: z.string().uuid(),
  OIDC_ORG_ID: z.string().uuid(),
  USER_POOL_ID: z.string(),
  USER_POOL_WEB_CLIENT_ID: z.string(),
  OIDC_CALLBACK_PATH: z.string().default('/oauth/callback'),
  SIGN_OUT_PATH: z.string().default('/logout'),
});
